    import axios from '../jslib/http'
    import qs from 'qs'

    const BASE_REQUEST = '/tms/sysCustomer'


    export function getAllCustomerList() {
        const url = `${BASE_REQUEST}/getAllCustomerList`
        var data = {}
        return axios
            .get(url, {
                params: data
            })
            .then(res => {
                if (res !== undefined) {
                    return Promise.resolve(res.data)
                } else {
                    return Promise.resolve(res)
                }
            })
    }

    export function getSysCustomerList(pageNo, pageSize,

        fullName,
        customerType,
        isBelisted
    ) {
        const url = `${BASE_REQUEST}/getSysCustomerList`
        var data = {
            pageNo: pageNo,
            pageSize: pageSize,

            fullName:fullName,
            customerType:customerType,
            isBelisted:isBelisted
        }
        return axios
            .get(url, {
                params: data
            })
            .then(res => {
                if (res !== undefined) {
                    return Promise.resolve(res.data)
                } else {
                    return Promise.resolve(res)
                }
            })
    }

    export function updateSysCustomer(
        obj
    ) {
        const url = `${BASE_REQUEST}/updateSysCustomer`
        var data = obj
        return axios
            .post(url, qs.stringify(data))
            .then(res => {
                if (res !== undefined) {
                    return Promise.resolve(res.data)
                } else {
                    return Promise.resolve(res)
                }
            })
    }

    export function delSysCustomer(
        id
    ) {
        const url = `${BASE_REQUEST}/delSysCustomer`
        var data = {
            id: id
        }
        return axios
            .get(url, {
                params: data
            })
            .then(res => {
                if (res !== undefined) {
                    return Promise.resolve(res.data)
                } else {
                    return Promise.resolve(res)
                }
            })
    }

    export function saveSysCustomer(
        obj
    ) {
        const url = `${BASE_REQUEST}/saveSysCustomer`
        var data = obj
        return axios
            .post(url, qs.stringify(data))
            .then(res => {
                if (res !== undefined) {
                    return Promise.resolve(res.data)
                } else {
                    return Promise.resolve(res)
                }
            })
    }

    export function getFatherList(
        id
    ) {
        const url = `${BASE_REQUEST}/getFatherList`
        var data = {
            id: id
        }
        return axios
            .get(url, {
                params: data
            })
            .then(res => {
                if (res !== undefined) {
                    return Promise.resolve(res.data)
                } else {
                    return Promise.resolve(res)
                }
            })
    }
    export function getCusNameById(
        customerIds
    ) {
        const url = '/tms/sysCustomerSecondlevel/getCusNameById'
        var data = {
            customerIds: customerIds
        }
        return axios
            .get(url, {
                params: data
            })
            .then(res => {
                if (res !== undefined) {
                    return Promise.resolve(res.data)
                } else {
                    return Promise.resolve(res)
                }
            })
    }